import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ReportRow, formStatusToApprovalStatus } from 'src/app/models/report.model';

@Component({
  selector: 'que-reports-menu-item',
  imports: [CommonModule, OverlayModule, TranslateDirective, TranslatePipe],
  templateUrl: './reports-menu-item.component.html',
  styleUrls: ['./reports-menu-item.component.scss']
})
export class ReportsMenuItemComponent {
  @Input() report?: ReportRow;
  @ViewChild('trigger') trigger!: ElementRef;
  #router = inject(Router);

  isMenuOpen = false;
  readonly positonArea = [{
    originX: 'center',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'top',
  }] as ConnectedPosition[];

  openMenu($event: Event) {
    $event.stopPropagation();
    const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    if (triggerRect.bottom + 200 > viewportHeight) {
      this.positonArea[0].overlayY = 'bottom';
    } else {
      this.positonArea[0].overlayY = 'top';
    }
    this.isMenuOpen = true
  }

  // Mirrors ReportsListItemComponent.reportClick() - see formStatusToApprovalStatus for why a
  // pending row is not forwarded as PendingApproval.
  viewRequest(event?: Event) {
    event?.stopPropagation();
    if (this.report?.recipientGuid) {
      this.#router.navigate([
        'viewAnswers',
        this.report.recipientGuid,
        formStatusToApprovalStatus(this.report.formStatus)
      ]);
    }
  }
}
